import React from 'react'
import Read from '@components/read'
import MainLayout from '@layouts/main-layout'
import { GetServerSideProps } from 'next'
import { isReadModuleEnabled } from '@lib/util/custom-config-handler'

const ReadPage = () => {
  return (
    <>
      <Read />
    </>
  )
}

ReadPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

// 404 the whole /read module when the admin toggle (custom config `show_read_module`) is off.
export const getServerSideProps: GetServerSideProps = async () => {
  if (!(await isReadModuleEnabled())) {
    return { notFound: true }
  }
  return { props: {} }
}

export default ReadPage
